// src/pages/HostingSupport.tsx
import React from 'react';

import { Link } from 'react-router-dom';
import SEO from "../components/SEO";
import { seoConfig } from "../seoConfig";

import { useImageParallax } from "../hooks/useImageParallax";


import GetInTouch from '../components/GetInTouch';

import hosting from '../assets/images/services/hosting.webp';

const HostingSupport: React.FC = () => {


const seo = seoConfig.hostingSupport; // ✅ Load meta for this page

useImageParallax(".anim-image-parallax"); // hook call


  return (


<>


      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url={seo.url}
        image={seo.image}
      />




  {/* rts bread crumba rea start */}
  <div className="rts-breadcrumb-area-hosting bg_image">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="baread-crumb-main-wrapper pt--100">
            <div className="inner">
              <h1 className="title rts_hero__title">Hosting & Support</h1>
              <span className="bg-text d-none d-md-inline">Manikarn Digital</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* rts bread crumba rea end */}

  {/* rts about area three */}
  <div
    className="rts-about-area parallax-about pt_sm--0 pb--80"
    id="about"
  >
    <div className="container">
      <div className="row g-5 align-items-center">
        <div className="col-lg-5">
          <a href="about.html" className="pli-image-link">
            <div className="pli-image-holder">
              {/* Use class "cover-opacity-*" to set image overlay if needed. For example "cover-opacity-2". Useful if class "pli-info-overlay" is enabled on "portfolio-list". Note: It is individual and depends on the image you use. More info about helper classes in file "helper.css". */}
              <figure className="pli-image">
                <img
                  className="anim-image-parallax tt-lazy"
                  src={hosting}
                  data-src={hosting}
                  alt="image"
                />
              </figure>{" "}
              {/* /.pli-image */}
            </div>{" "}
            {/* /.pli-image-holder */}
          </a>{" "}
          {/* /.pli-image-link */}
        </div>
        <div className="col-lg-7">

  <div className="content-wrapper">
    <span className="sub-title">MANIKARN DIGITAL</span>
    <h2 className="title mt--15 mb--20 mt_sm--10 mb_sm--10">
      Reliable Hosting & Dedicated Support for Your Business
    </h2>
    <p className="disc">
      At <strong>Manikarn Digital</strong>, we don’t just design and develop websites—we ensure they perform at their best with our reliable Hosting & Support services. A fast, secure, and well-maintained website is the backbone of any successful online business, and our team is here to make sure your website runs smoothly - 24/7.
    </p>
    <Link to="/contact" className="learn-more-btn mt--30">
      Contact Us <i className="fa-solid fa-arrow-up-right-from-square"></i>
    </Link>
  </div>


        </div>
      </div>
    </div>
  </div>
  {/* rts about area three end */}


    {/* service area start */}
  <div className="rts-servicearea-start pt_sm--0 pb--100 pb_sm--20">
    <div className="container">
      <div className="row mb--10">
        <div className="col-lg-12 mx-auto">

  <div className="content-wrapper text-center">
    <span className="sub-title">MANIKARN DIGITAL</span>
    <h2 className="title mt--15 mb--20 mt_sm--10 mb_sm--10">
      Powerful Hosting & Expert Support – Keep Your Website Fast, Secure & Always Online
    </h2>
  </div>


        </div>
      </div>
      <div className="row g-2">
        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
          {/* single service area start */}
          <div className="single-service-style-seven">
            <div className="icon">

<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 60 60" fill="none">
  <g stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none">

    <rect x="10" y="12" width="28" height="10" rx="2" stroke-dasharray="120" stroke-dashoffset="120">
      <animate attributeName="stroke-dashoffset" values="120;0;120" dur="6s" repeatCount="indefinite"/>
    </rect>
    <rect x="10" y="24" width="28" height="10" rx="2" stroke-dasharray="120" stroke-dashoffset="120">
      <animate attributeName="stroke-dashoffset" values="120;0;120" dur="6s" begin="0.2s" repeatCount="indefinite"/>
    </rect>
    <rect x="10" y="36" width="28" height="10" rx="2" stroke-dasharray="120" stroke-dashoffset="120">
      <animate attributeName="stroke-dashoffset" values="120;0;120" dur="6s" begin="0.4s" repeatCount="indefinite"/>
    </rect>

 
    <circle cx="15" cy="17" r="1.4" fill="currentColor">
      <animate attributeName="opacity" values="1;0.3;1" dur="2.6s" repeatCount="indefinite"/>
    </circle>
    <circle cx="15" cy="29" r="1.4" fill="currentColor">
      <animate attributeName="opacity" values="1;0.3;1" dur="2.6s" begin="0.2s" repeatCount="indefinite"/>
    </circle>
    <circle cx="15" cy="41" r="1.4" fill="currentColor">
      <animate attributeName="opacity" values="1;0.3;1" dur="2.6s" begin="0.4s" repeatCount="indefinite"/>
    </circle>

  
    <path d="M38 20 L50 24 V33c0 7-5 12-12 15c-7-3-12-8-12-15v-9z" fill="none" opacity="0.4">
      <animateTransform attributeName="transform" type="translate" values="0 0;0 -1;0 0" dur="2.2s" repeatCount="indefinite"/>
    </path>


    <path d="M38 30 h4 l2 3 l2-5 l2 4 h4" fill="none" opacity="0.4">
      <animate attributeName="stroke-width" values="2.4;3;2.4" dur="2.4s" repeatCount="indefinite"/>
      <animate attributeName="opacity" values="0.5;1;0.5" dur="2.4s" repeatCount="indefinite"/>
    </path>
  </g>
</svg>




            </div>
            <h5 className="title-1">
              Secure & Scalable Hosting
            </h5>
            <p className="disc">
              Our hosting solutions are built for speed, security, and scalability. Whether you’re running a small business website, an eCommerce store, or a corporate portal, we provide hosting plans tailored to meet your needs. With advanced security measures, daily backups, and guaranteed uptime, your website stays protected and accessible at all times.
            </p>
          </div>
          {/* single service area end */}
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
          {/* single service area start */}
          <div className="single-service-style-seven">
            <div className="icon">

<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 60 60" fill="none">
  <g stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none">

    <path d="M12 30a18 18 0 1 1 36 0" />
    <rect x="8" y="30" width="8" height="12" rx="2" />
    <rect x="44" y="30" width="8" height="12" rx="2" />
    <path d="M44 42 q4 0 4 4 v2" />
    <circle cx="30" cy="28" r="10" stroke-dasharray="160" stroke-dashoffset="160">
      <animate attributeName="stroke-dashoffset" values="160;0;160" dur="4.2s" repeatCount="indefinite"/>
    </circle>


    <g transform="translate(30 28)">
      <circle r="3" />
      <g>
        <line x1="6" y1="0" x2="9" y2="0" />
        <line x1="-6" y1="0" x2="-9" y2="0" />
        <line x1="0" y1="6" x2="0" y2="9" />
        <line x1="0" y1="-6" x2="0" y2="-9" />
        <line x1="4.2" y1="4.2" x2="6.3" y2="6.3" />
        <line x1="-4.2" y1="4.2" x2="-6.3" y2="6.3" />
        <line x1="4.2" y1="-4.2" x2="6.3" y2="-6.3" />
        <line x1="-4.2" y1="-4.2" x2="-6.3" y2="-6.3" />
      </g>
      <animateTransform attributeName="transform" type="rotate" values="0 0 0;360 0 0" dur="4s" repeatCount="indefinite"/>
    </g>


    <circle cx="48" cy="44" r="2.6" fill="currentColor">
      <animate attributeName="r" values="2.6;4;2.6" dur="1.2s" repeatCount="indefinite"/>
      <animate attributeName="opacity" values="1;0.4;1" dur="1.2s" repeatCount="indefinite"/>
    </circle>
  </g>
</svg>






            </div>
            <h5 className="title-1">
              Dedicated Technical Support
            </h5>
            <p className="disc">
              We believe great hosting is incomplete without reliable support. Our expert support team is always available to troubleshoot issues, provide guidance, and ensure your website stays up-to-date. From plugin updates and bug fixes to performance monitoring and malware protection, we handle it all so you can focus on growing your business.
            </p>

          </div>
          {/* single service area end */}
        </div>


      </div>
    </div>
  </div>
  {/* service area ends */}





{/* ==== GetInTouch Section start ==== */}
<GetInTouch />
{/* ==== / GetInTouch Section end ==== */}  


</>   


  );
};

export default HostingSupport;
